export enum AutocompleteItemType {
  Feedback = "Feedback",
  App = "App",
  User = "User"
}

export enum SearchContextType {
  All = "All",
  App = "App",
  Topic = "Topic"
}

export enum AppSelectorGroup {
  Applications = "Applications",
  Topics = "Topics"
}

export enum AddFeedbackButtonType {
  Icon = "Icon",
  Button = "Button"
}
